import { Component, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { ExternalLink, Info } from 'lucide-angular';

import { NavbarMenuItemComponent } from '../navbar-menu-item/navbar-menu-item.component';

@Component({
  selector: 'di-navbar-secondary-menu-mobile',
  templateUrl: './navbar-secondary-menu-mobile.component.html',
  standalone: false,
})
export class NavbarSecondaryMenuMobileComponent {
  @Input() parentLabel = '';
  @Input() menuItems!: QueryList<NavbarMenuItemComponent>;

  @Output() readonly menuItemClick = new EventEmitter<void>();

  protected readonly icons = { ExternalLink, Info };

  protected onMenuItemClick(event: MouseEvent, menuItem: NavbarMenuItemComponent): void {
    menuItem.click.emit(event);
    this.menuItemClick.emit();
  }
}
